<div class="page">
    To contact RealmBreak Games support, please email us at <a href="mailto:realmbreakgameshelp@gmail.com">realmbreakgameshelp@gmail.com</a> or chat with us on our <a href="https://discord.gg/x2aXAZQAhP" target="_blank">Discord Server</a>.
</div>
